/**
 * @param {*} data : response from get devices api for given device model
 * @returns Array of objects as required by devices table
 */
export const convertDeviceList = (data) => {
  const list = data.devices ? data.devices : [];
  return list.map((item) => {
    return {
      key: item.deviceuuid,
      deviceUuid: item.deviceuuid,
      deviceModelId: item.devicemodelid,
      groupId: item.groupid,
      deviceId: item.deviceid,
      modelNumber: item.modelnumber,
      groupName: item.groupname,
      deviceName: item.devicename,
      deviceDescription: item.devicedescription,
      baseMacAddress: item.basemacaddress,
      category: item.category,
      status: item.devicestatus,
      productClass: item.productclass,
      softwareVersion: item.softwareversion,
      additionalSoftwareVersion: item.additionalsoftwareversion,
      deviceActivationDate: item.deviceactivationdate,
      operationalStatus: item.operationalstatus,
      provisioningCode: item.provisioningcode,
      enabledOptions: item.enabledoptions,
      firstUseDate: item.firstusedate,
      deviceInfo: item.deviceinfo,
      deviceLog: item.devicelog,
      uptime: item.uptime,
      lan: item.lan,
    };
  });
};

/**
 * @param {*} data : response from get devices api for given device model
 * @returns Array of objects as required by dropdown
 */
export const convertDeviceListToDropdown = (data) => {
  const list = data.devices ? data.devices : [];
  return list.map((item) => {
    return {
      deviceId: item.deviceid,
      deviceUuid: item.deviceuuid,
      modelId: item.devicemodelid,
    };
  });
};

/**
 * @param {*} data : list of selected devices
 * @returns Array of objects as required update api
 */
export const convertDependentDeviceListToApiValues = (data) => {
  const returnData = { dependentdevices: [] };
  data?.forEach((item) => {
    returnData.dependentdevices.push({
      deviceuuid: item.deviceUuid,
    });
  }, []);
  return returnData;
};
